import React from "react";
import { AiOutlineMail } from "react-icons/ai";

const teamCardDetails = [
  {
    id: 1,
    img: "/img/home/team5.jpg",
    name: "Jenifer Loley",
    email: "help@zamchainadvanceinvestment.com",
    about:
      " Our professionals team are educated and talented traders. Our experts give you benefit from total transparency to achieve control and make better decisions.",
  },
  {
    id: 2,
    img: "/img/home/team6.jpg",
    name: "Micheal Scott",
    email: "help@zamchainadvanceinvestment.com",
    about:
      " Our professionals team are educated and talented traders. Our experts give you benefit from total transparency to achieve control and make better decisions.",
  },
  {
    id: 3,
    img: "/img/home/team7.jpg",
    name: "Calon Scot",
    email: "help@zamchainadvanceinvestment.com",
    about:
      " Our professionals team are educated and talented traders. Our experts give you benefit from total transparency to achieve control and make better decisions.",
  },
  {
    id: 4,
    img: "/img/home/team3.jpeg",
    name: "John Jeff",
    email: "help@zamchainadvanceinvestment.com",
    about:
      " Our professionals team are educated and talented traders. Our experts give you benefit from total transparency to achieve control and make better decisions.",
  },
];

export const TeamCard = () => {
  return (
    <>
      {teamCardDetails.map(({ id, img, name, email, about }) => (
        <div key={id} className="border shadow bg-gray-50">
          <img src={img} alt="" className="object-cover h-[300px] w-full" />

          <div className="py-2 px-4">
            <h4 className=" text-lg mt-2 font-heading font-medium">{name}</h4>
          </div>
        </div>
      ))}
    </>
  );
};
